import { useSelector } from 'react-redux'

import { RootState } from '../../../reducers'
import { botDiffSelector } from '../selectors'

export function useDiff() {
  return useSelector<RootState, string>(botDiffSelector)
}
